import { getSkipItems, setSkipItems, SkipItem } from './userStoredConfig';

export function setSkipItem(item: SkipItem, isActive: boolean) {
    const itemsSet = new Set(getSkipItems());
    isActive ? itemsSet.add(item) : itemsSet.delete(item);
    setSkipItems(Array.from(itemsSet));
}
